// @file Helper functions for billing components.
import { UpgradeStep } from 'vuexstore/modules/plans'

enum SwitchType {
  SwitchImmediately = 'switch_immediately',
  SwitchAtEndOfTerm = 'switch_at_end_of_term',
}

enum CancellationType {
  EndSubscription = 'end_subscription',
  SetAsNonRenewing = 'set_as_non_renewing',
}

function getUpgradeStepFromQuota(currentUserQuota): UpgradeStep {
  if (currentUserQuota.walls_used === currentUserQuota.walls_limit) return UpgradeStep.AtPadletQuota
  else if (currentUserQuota.walls_used < currentUserQuota.walls_limit) return UpgradeStep.BelowPadletQuota
  return UpgradeStep.OverPadletQuota
}

function normalizedPaymentSchedule(paymentSchedule: string): 'monthly' | 'annual' {
  return paymentSchedule === 'month' ? 'monthly' : 'annual'
}

export { CancellationType, getUpgradeStepFromQuota, normalizedPaymentSchedule, SwitchType }
